var _classCallCheck = require("/home/neveragain_jail/home/neveragain/django/neveragain/frontend/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/home/neveragain_jail/home/neveragain/django/neveragain/frontend/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/neveragain_jail/home/neveragain/django/neveragain/frontend/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/neveragain_jail/home/neveragain/django/neveragain/frontend/node_modules/@babel/runtime/helpers/inherits");

var _wrapNativeSuper = require("/home/neveragain_jail/home/neveragain/django/neveragain/frontend/node_modules/@babel/runtime/helpers/wrapNativeSuper");

var ParameterError =
/*#__PURE__*/
function (_Error) {
  "use strict";

  _inherits(ParameterError, _Error);

  function ParameterError(message) {
    var _this;

    _classCallCheck(this, ParameterError);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ParameterError).call(this, message));
    _this.message = message;
    _this.name = 'ParameterError';
    return _this;
  }

  return ParameterError;
}(_wrapNativeSuper(Error));

var LinkLookupError =
/*#__PURE__*/
function (_Error2) {
  "use strict";

  _inherits(LinkLookupError, _Error2);

  function LinkLookupError(message) {
    var _this2;

    _classCallCheck(this, LinkLookupError);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(LinkLookupError).call(this, message));
    _this2.message = message;
    _this2.name = 'LinkLookupError';
    return _this2;
  }

  return LinkLookupError;
}(_wrapNativeSuper(Error));

var ErrorMessage =
/*#__PURE__*/
function (_Error3) {
  "use strict";

  _inherits(ErrorMessage, _Error3);

  function ErrorMessage(message, content) {
    var _this3;

    _classCallCheck(this, ErrorMessage);

    _this3 = _possibleConstructorReturn(this, _getPrototypeOf(ErrorMessage).call(this, message));
    _this3.message = message;
    _this3.content = content;
    _this3.name = 'ErrorMessage';
    return _this3;
  }

  return ErrorMessage;
}(_wrapNativeSuper(Error));

module.exports = {
  ParameterError: ParameterError,
  LinkLookupError: LinkLookupError,
  ErrorMessage: ErrorMessage
};